/** Lifecycle of the drone's last firmware (OTA) update attempt. */
export enum OtaUpdateStatus {
  INITIAL = 'INITIAL',
  REQUESTED = 'REQUESTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  TIMED_OUT = 'TIMED_OUT',
  DEFERRED = 'DEFERRED',
  CANCELLED = 'CANCELLED',
}

/** Version verdict colour: required is blocking (red), recommended is optional (yellow). */
export type OtaVersionTone = 'error' | 'warning';

export interface DroneOtaEntity {
  currentVersion: string | null;
  recommendedVersion: string | null;
  updateRequired: boolean;
  updateRecommended: boolean;
  lastUpdateAt: string | null;
  lastUpdateStatus: OtaUpdateStatus | null;
}

/**
 * The single source of truth for whether a firmware verdict exists and its colour.
 * `updateRequired` wins over `updateRecommended`; returns null when the drone is up to date.
 */
export function getOtaVersionTone(ota: DroneOtaEntity | null | undefined): OtaVersionTone | null {
  if (!ota) return null;
  if (ota.updateRequired) return 'error';
  if (ota.updateRecommended) return 'warning';
  return null;
}
